// Alertas calculadas en lectura desde la vista SQL v_alertas.
// Se enriquecen con el formato que consume la UI (tipo/nivel/mensaje) y se
// ordenan con los agotados primero.
import { insforge } from '../insforge';
import type { Alerta } from '../../types';

interface VistaAlerta {
  bodega_id: string;
  bodega: string;
  item_id: string;
  item_nombre: string;
  stock: number;
  stock_minimo: number;
  nivel: 'agotado' | 'bajo';
}

export async function listarAlertas(): Promise<Alerta[]> {
  const { data, error } = await insforge.database.from('v_alertas').select('*');
  if (error) throw new Error(error.message);

  const alertas = ((data ?? []) as VistaAlerta[]).map<Alerta>((a) => {
    const agotado = a.nivel === 'agotado';
    return {
      bodega_id: a.bodega_id,
      bodega: a.bodega,
      item_id: a.item_id,
      item_nombre: a.item_nombre,
      stock: Number(a.stock),
      stock_minimo: Number(a.stock_minimo),
      tipo: a.nivel,
      nivel: agotado ? 'error' : 'warning',
      mensaje: agotado
        ? `${a.item_nombre} está agotado en ${a.bodega}.`
        : `${a.item_nombre}: quedan ${a.stock} unidades (mínimo ${a.stock_minimo}).`,
    };
  });

  // Agotados (error) primero.
  alertas.sort((x, y) => (x.nivel === 'error' ? 0 : 1) - (y.nivel === 'error' ? 0 : 1));
  return alertas;
}
